import React from 'react';
import ReactDOM from 'react-dom';
import { MantineProvider } from '@mantine/core';
import App from './App';
import { AppContextProvider } from './AppContext';
import 'bootstrap/dist/css/bootstrap.min.css';


ReactDOM.render(
  <MantineProvider>
    <AppContextProvider>
      <App />
    </AppContextProvider>
  </MantineProvider>,
  document.getElementById('root')
);